/**
 * 声纹「即录即证」朗读文本(B5 二刀)。用户现场朗读这段文本录音 → 录音本身就是授权存证,
 * 版本号随克隆请求落 xb_dh_consent.consent_text_version(改文本必须升版本号,旧存证可溯源)。
 *
 * ★v2(2026-09-08 声音 V2 拍板):朗读文本从授权声明换成一段**自然的业务介绍**。
 *   两个动机:① 克隆质量 —— 声明式短句录出来的声线发紧,自然介绍段更接近成片口播的
 *   讲话状态(DH_VOICE_SAMPLE_RULE 的「念完整自然句子」同一条理);② 引导文本正好
 *   展示克隆后的用途。授权语义不减:录制入口仍在「用我自己的声音」卡内、上传路仍走
 *   显式勾选,record 路的 consentTextVersion 照落 v2 —— 用户读的是哪一版文本可溯源。
 */
export const DH_VOICE_CONSENT_TEXT_VERSION = "v2";

export const DH_VOICE_CONSENT_TEXT =
  "大家好,我是公司的负责人。今天想用一分钟时间,和大家介绍一下我们的产品。" +
  "我们一直希望把复杂的事情做得更简单,帮助客户用更低的成本解决实际问题。";

/**
 * DashScope 声纹样本硬约束:上游硬限 20 秒(超了直接拒)→ 录音下限 10 秒 / 19 秒自动停。
 * 对外统一口径(修复波 0926 P3):「朗读 10 秒以上,录到 19 秒自动停」;别再写「10~20 秒」。
 */
export const DH_VOICE_RECORD_MIN_SECONDS = 10;
export const DH_VOICE_RECORD_MAX_SECONDS = 19;

/**
 * 声纹样本「该说什么」的红线(2026-08-13 文强报障后补)。
 *
 * ★不是排版建议,是**实测**得出的:克隆音色合成时会把样本里的内容念进成片 ——
 *   样本是「1 2 3 …10」数数,出片就多出「8 9 10 1 2 3 4 5 6 7」;另一条样本是
 *   「Trial. Trial. Trial.」,出片就多出 "Trial"。而且同一条声纹**每次都漏**(测试机
 *   同音色同文案连跑 5 次时长一模一样),换重试没用,只能从样本这一头躲开。
 *
 * ★三处入口共用这一句(上传样本 / 即录即证 / 视频形象「用原声」抽的那段音轨),
 *   散着抄三份的话,改一处只会让另外两处继续教用户数数。
 */
export const DH_VOICE_SAMPLE_RULE =
  "念一段完整的自然句子(读一段介绍、念引导文本都行)。别数数、别反复念同一个词 —— " +
  "样本里念了什么,以后出片就可能被夹进口播里。";
